/* eslint-disable camelcase */
export const oidcSettings = {
    authority: document.getElementById('oidcAuthority').value, // Your Criipto Domain eg. https://<YOUR_COMPANY>.criipto.id
    client_id: 'urn:criipto:signupTalkmoreCriipto:no1', // Your Criipto Client ID/Realm
    response_type: 'id_token', // The type of response desired from Criipto Verify
    redirectUri: document.getElementById('oidcRedirectUri').value, // The redirect URI of the client application to receive a response from the OIDC/OAuth2 provider
    popupRedirectUri: document.getElementById('oidcRedirectUri').value,
    scope: 'openid address email phone birthdate', // The scope being requested from the OIDC/OAuth2 provider
    post_logout_redirect_uri: document.getElementById('oidcRedirectUri').value,
    // acr_values: 'urn:grn:authn:no:bankid', // Specific authentication service to use eg. for login with Vipps app: urn:grn:authn:no:vipps
    popupWindowFeatures: 'location=no,toolbar=no,width=600,height=500,left=100,top=100', // Use this to customize a popup window
    popupWindowTarget: '_self', // Defines the 'name'-tag value for the iframe
    ui_locales: 'nb', // https://docs.criipto.com/how-to/choose-language/
    prompt: 'login',
};
export const partnerOidcSettings = {
    authority: document.getElementById('partnerOidcAuthority').value,
    client_id: 'pnTalkmore',
    response_type: 'code',
    redirectUri: document.getElementById('partnerOidcRedirectUri').value, // The redirect URI of the client application to receive a response from the OIDC/OAuth2 provider
    scope: 'openid profile http://id.trumf.no/scopes/medlem', // The scope being requested from the OIDC/OAuth2 provider
    popupWindowTarget: '_self', // Defines the 'name'-tag value for the iframe
    ui_locales: 'nb', // https://docs.criipto.com/how-to/choose-language/,
    grant_type: 'authorization_code',
};